<style>
    .titlebl{
        font-weight: 500;
        color: black;
        margin-top: 5px;
        margin-left: 8px;
    }
</style>
<template  style="background: #f5f5f5;">
    <v-container fluid>
        <v-layout style="flex-direction: column;align-items: center;">
            <v-card style="width:95%;" elevation="6">
                <v-list-item two-line>
                    <v-list-item-content>                                                        
                        <v-toolbar flat color="white">
                            <v-toolbar-title class="titleogl">BL</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>                            
                            <v-spacer></v-spacer>
                        </v-toolbar>                        
                    </v-list-item-content>
                </v-list-item>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-btn @click="crearPDF">Guardar</v-btn>
                        </v-col>
                    </v-row>
                    <div id="Bl">                 
                        <v-row>
                            <v-col style="margin-bottom: 25px;">
                                <v-img src="@/assets/logo-co2.png" max-width="220px" max-height="100"></v-img> 
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                
                            </v-col>
                        </v-row>                    
                        <v-row>
                            <v-col>
                                    <v-row style="border-top: 1px solid rgb(2, 2, 2);border-bottom: 1px solid black;">
                                        <v-col >
                                            <span class="titlebl">Vessel</span>
                                        </v-col>
                                        <v-col>
                                            <v-label v-model="vessel">MOL PACE</v-label>
                                        </v-col>
                                        <v-col>
                                            <v-label style="text-align: end;">
                                                2009E
                                            </v-label>
                                        </v-col>
                                    </v-row>
                                    <v-row style="flex-direction: column;">
                                        <v-col>
                                            <span class="titlebl">
                                                Shipper
                                            </span>
                                        </v-col>
                                        <v-col style="border-bottom: 1px solid #020202;padding: 8px">
                                            <v-label v-model="shipper">MOLINOS DEL SUDESTE SA DE CV
                                                RFC: MSU850911A56
                                                AV. INDUSTRIAL PUEBLA No.562 P.I.VALLE DE PUEBLA EJIDO PUEBLA C.P. 21620 MEXICALI, BC, MEXICO
                                                CTC. MARTHA BURGOS TEL. +52 686 500 1518
                                            </v-label>
                                        </v-col >
                                    </v-row>
                                    <v-row style="flex-direction: column;">
                                        <v-col>
                                            <span class="titlebl">Forwading Agent</span>
                                        </v-col>
                                        <v-col style="border-bottom: 1px solid #020202;padding: 8px">
                                            <v-label v-model="agent">INFINITY LOGISTICS AGENCY CORP.
                                                155602360-2-2015 D.V.05 ZONA LIBRE DE COLÓN, REP. DE PANAMÁ  FRANCE FIELD, EDIFICIO MAURIA LOCAL 9 0302-0004 ZL, REP. DE PMA.  
                                                CTC: MADELEIN BECERRA 
                                                PHONE: +507-430.4648
                                                </v-label>
                                        </v-col >
                                    </v-row>
                                    <v-row style="flex-direction: column;">
                                        <v-col>
                                            <span class="titlebl">Consignee</span>
                                        </v-col>
                                        <v-col style="border-bottom: 1px solid #020202;padding: 8px">
                                            <v-label v-model="consignee">PRODUCTOS ALIMENTICIOS PASCUAL S.A. RUC: 14756940208CV18 VIA 
                                            JOSE AGUSTIN ARANGO, JUAN DIAZ PANAMA, REPUBLICA DE PANAMA
                                            CTC: MIRIEL ZEBALLOS 
                                            PH:+507 217 2233</v-label>
                                        </v-col>
                                    </v-row>
                                    <v-row style="flex-direction: column;">
                                        <v-col>
                                            <span class="titlebl">Notify Party</span>
                                        </v-col>
                                        <v-col style="padding: 8px">
                                            <v-label>
                                                PRODUCTOS ALIMENTICIOS PASCUAL S.A. RUC: 14756940208CV18 VIA 
                                                JOSE AGUSTIN ARANGO, JUAN DIAZ PANAMA, REPUBLICA DE PANAMA
                                                CTC: MIRIEL ZEBALLOS 
                                                PH:+507 217 2233
                                            </v-label>
                                        </v-col>
                                    </v-row>
                            </v-col>
                            <v-row style="flex-direction: column;align-items: center;">
                                <v-col style="display: flex;align-items: center;">                            
                                    <v-img style="margin: 0 auto;" src="@/assets/logo-co2.png" max-width="450px" ></v-img> 
                                </v-col>
                                <v-col style="min-height: 150px;width: 90%;display: flex;align-items: center;text-align: center;border: 1px solid;">
                                    <span style="font-size: 85px;color: black;width: 100%;">DRAFT</span>
                                </v-col>
                                <v-col style="max-height: 78px;width: 90%;">
                                    <v-row style="align-items: center;padding: 8px;">
                                        <v-col>
                                            <v-label>Pre-carriage by</v-label>
                                        </v-col>
                                        <v-col>
                                            <v-label>Place of Receipt</v-label>
                                        </v-col>
                                    </v-row>
                                    <v-row style="align-items: center;padding: 8px;">
                                        <v-col>
                                            <v-label>0</v-label>
                                        </v-col>
                                        <v-col>
                                            <v-label>ENSENADA, MEXICO </v-label>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>                        
                        </v-row>
                        <v-row style="border-top: 1px solid black;padding: 5px;"> 
                            <v-col>
                                <v-label>Port of Loading</v-label>
                            </v-col>
                            <v-col>
                                <v-label>
                                    Port of Discharge
                                </v-label>
                            </v-col>
                            <v-col>
                                <v-label>Port of Transhipment</v-label>
                            </v-col>
                            <v-col>
                                <v-label>Place of delivery</v-label>
                            </v-col>
                            <v-col>
                                <v-label>Export Reference</v-label>
                            </v-col>
                        </v-row>
                        <v-row style="border-top: 1px solid black;padding: 5px;">
                            <v-col>
                                <v-label>ENSENADA, MEXICO </v-label>
                            </v-col>
                            <v-col>
                                <v-label>MANZANILLO, PANAMA</v-label>
                            </v-col>
                            <v-col>
                                <v-label>0</v-label>
                            </v-col>
                            <v-col>
                                <v-label>MANZANILLO, PANAMA	</v-label>
                            </v-col>
                            <v-col>
                                <v-label>FEX00004235</v-label>
                            </v-col>
                        </v-row>
                        <v-row style="border-top: 1px solid black;padding: 5px;">
                            <v-col>
                                <v-label>PAGE 2/2</v-label>
                            </v-col>
                            <v-col>
                                <v-label>PARTICULARS DECLARED BY THE SHIPPER</v-label>
                            </v-col>
                        </v-row>
                        <v-row style="border-top: 1px solid black;padding: 5px;">
                            <v-col md="3" lg="3" >
                                <v-label>Cont # Seal # Marks and Nos</v-label>
                            </v-col>
                            <v-col md="1" lg="1">
                                <v-label>NR and Kind of Pkgs</v-label>
                            </v-col>
                            <v-col md="4" lg="4">
                                <v-label>Description of Goods</v-label>
                            </v-col>
                            <v-col md="3" lg="3">
                                <v-label>Grossweight</v-label>
                            </v-col>
                            <v-col ><v-label>(Cu.M.)</v-label></v-col>
                        </v-row>
                        <v-row>
                            <v-col  md="3" lg="3">
                                <v-label>                                
                                GESU3873266
                                SEAL: 0053022

                                AMFU3213472
                                SEAL: 0053021

                                GLDU5712077
                                SEAL: 0053036

                                FCIU2434990
                                SEAL: 0053037"							
                                </v-label>
                            </v-col>
                            <v-col  md="1" lg="1">
                                <v-label>                                
                                    1X20 DC


                                    1X20 DC 


                                    1X20 DC


                                    1X20 DC
                                </v-label>
                            </v-col>
                            <v-col md="4" lg="4">
                                <v-label >
                                    SAID TO CONTAIN:

                                    500 BAGS WITH DURUM WHEAT SEMOLINA


                                    500 BAGS WITH DURUM WHEAT SEMOLINA


                                    500 BAGS WITH DURUM WHEAT SEMOLINA


                                    500 BAGS WITH DURUM WHEAT SEMOLINA

                                </v-label>
                            </v-col>
                            <v-col md="3" lg="3">
                                <v-label>
                                    
                                    22,000.00 KGS


                                    22,000.00 KGS


                                    22,000.00 KGS


                                    22,000.00 KGS	
                                </v-label>
                            </v-col>
                            <v-col>
                                <v-label>0</v-label>
                            </v-col>
                        </v-row>
                    </div>
                    </v-card-text>                
            </v-card>
        </v-layout>
    </v-container>
</template>
<script>
import axios from 'axios'
import jsPDF from 'jspdf'
import autotable from 'jspdf-autotable';
import html2canvas from 'html2canvas';
export default {
    data(){
        return{

        }
    },
    methods:{
        crearPDF(){
        var columns =[
          {title:"ID", dataKey:"id"},
          {title:"Name",dataKey:"name"},
          {title:"Country",dataKey:"country"},
          {title:"Region",dataKey:"region"}
        ];
        var rows=[
          {"id":1,"name":"Shaw","country":"Tanzania","region":"5412"},
          {"id":2,"name":"Shaw","country":"Tanzania","region":"5412"},
          {"id":3,"name":"Shaw","country":"Tanzania","region":"5412"},
          {"id":4,"name":"Shaw","country":"Tanzania","region":"5412"},
          {"id":5,"name":"Shaw","country":"Tanzania","region":"5412"}
        ];

        var doc= document.getElementById('Bl');
        html2canvas(doc).then(function(canvas){
            var dot = new jsPDF();
            var position = 0;
            dot.save('BL');
        });
       /* var doc = new jsPDF('p','pt');
        doc.autoTable(columns, rows,{
          styles:{fillcolor:[100,255,255]},
          columnStyle:{
            id:{fillcolor:255}
          },
          margin:{top:60},
          addPageContent:function(data){
            doc.text("Listado de Actividades",40,30);
          }
        });
        doc.save("table.pdf");*/

      },
    }
}
</script>